import logo from './logo.svg';
import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import Login from './login/Login';
import Dashboard from './dashboard/Dashboard';
import Upload from './dashboard/upload/Upload';
import FileTable from './dashboard/FilesList/FilesList';
import Reset from './reset/Reset';
import Signup from './signup/Signup';
import Autoaccept from './Auto/Autoaccept';
import FirsttimeReset from './reset/FirsttimeReset';
import Admin from './dashboard/admin/Admin';
import { useContext } from 'react';
import UserContext from './context/UserContext';
import Customer from './dashboard/admin/Customer';
import CustFiles from './dashboard/FilesList/CustFiles';
import CustUpload from './dashboard/admin/CustUpload';
import Settings from './dashboard/admin/Settings';
import { Navigate, Outlet } from 'react-router-dom';
import PasswordReset from './reset/Passresetemail';
import Download from './dashboard/upload/Download';

// ProtectedRoute component
const ProtectedRoute = () => {
  const { userInfo } = useContext(UserContext);
  const location = useLocation();
  const isAuthenticated = !!userInfo?._id || !!sessionStorage.getItem('user');

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location.pathname + location.search }} replace />;
  }

  return <Outlet />;
};

function App() {
  const { userInfo } = useContext(UserContext);

  return (
    <div className="App">
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Login />} />
        <Route path="/autoaccept" element={<Autoaccept />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/passreset/:id" element={<FirsttimeReset />} />
         <Route path="/passreset" element={<PasswordReset />} />
  <Route path="/passwordreset" element={<Reset />} />
  <Route path="download/:company/:filename" element={<Download />} />
        {/* Protected routes under /dashboard */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />}>
                
            <Route path="custfiles" element={<CustFiles />} />
            <Route path="custfiles/upload" element={<CustUpload />} />
            <Route path="upload" element={<Upload />} />
            <Route path="site" element={<Settings />} />
            <Route path="customer/:id" element={<Customer />} />
            <Route
              path=""
              element={userInfo?.level === '9' ? <Admin /> : <FileTable />}
            />
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;